import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(public)/eventos/event-list.tsx");
